import React from 'react'
import HighlightedText from '../../Utils/HighlightedText'
import styles from './styles.module.css'
import CtaV2 from '../../CtaV2'
import Text from '../../Text'
import CheckmarkIconWhite from '../../icons/CheckmarkIconWhite'
import { $textPrimary } from '../../../styles/colors/semantics'

function ConversionCta({ titleHl, subtitleHl, ctasV2 }) {
  return (
    <>
      <div className={`${styles.conversionCtaWrapper} p-[5%] flex flex-col items-center text-center py-20 lg:py-40`}>
        <div className="container flex flex-col gap-4">
          <div className="flex flex-col gap-4 items-center">
            { <HighlightedText {...titleHl}/> }
            <div className="lg:max-w-1/2">
              { <HighlightedText {...subtitleHl}/> }
            </div>
          </div>
        </div>
        <div className="flex gap-4 flex-wrap py-10 md:py-16 justify-center ">
          { renderChecklistItem('Premium performance') }
          { renderChecklistItem('Money-back guarantee') }
          { renderChecklistItem('3-year warranty') }
          { renderChecklistItem('Industry-leading support') }
        </div>
        <div className="flex gap-2">
          { ctasV2 && ctasV2.map((ctaV2, i) => (
              <CtaV2 {...ctaV2}
                     key={`cta-${i}`}
              />
          ))}
        </div>
      </div>
    </>
  )
}

function renderChecklistItem(text) {
  return (
    <div className="flex gap-1 px-2">
      <CheckmarkIconWhite/>
      <Text type="medium" color={$textPrimary.dark}>{text}</Text>
    </div>
  )
}

export default ConversionCta
